// extracted by css-extract-rspack-plugin
export default {"icon":"icon-uER0Ih flex items-center","status":"status-qvft7Z flex items-center justify-end pr-md"};